import { useState, useEffect, useCallback } from 'react';

/**
 * Хук для управления состояниями виджета
 * Использует FSM подход для управления этапами работы виджета
 */
export const useWidgetState = () => {
  const [state, setState] = useState('idle'); // idle, uploading, uploaded, processing, result, error
  const [error, setError] = useState(null);

  /**
   * Переход в состояние загрузки
   */
  const setUploading = useCallback(() => {
    setState('uploading');
    setError(null);
  }, []);

  /**
   * Переход в состояние загружено
   */
  const setUploaded = useCallback(() => {
    setState('uploaded');
    setError(null);
  }, []);

  /**
   * Переход в состояние обработки
   */
  const setProcessing = useCallback(() => {
    setState('processing');
    setError(null);
  }, []);

  /**
   * Переход в состояние результата
   */
  const setResult = useCallback(() => {
    setState('result');
    setError(null);
  }, []);

  /**
   * Переход в состояние ошибки
   */
  const setErrorState = useCallback((errorMessage) => {
    setState('error');
    setError(errorMessage);
  }, []);

  /**
   * Сброс к начальному состоянию
   */
  const reset = useCallback(() => {
    setState('idle');
    setError(null);
  }, []);

  return {
    state,
    error,
    setUploading,
    setUploaded,
    setProcessing,
    setResult,
    setError: setErrorState,
    reset,
    setState, // для прямого управления, если необходимо
  };
};

export default useWidgetState;

